
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/apartment-move-out",
      function () {
        return require("private-next-pages/services/apartment-move-out.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/apartment-move-out"])
      });
    }
  